import React from 'react';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from '@app/layouts/layout';
import { QmManageCommands } from '@app/pages/qm-module/qm-manage-commands';

import RequiredAuth from '../required-auth.route';

export const qmManageCommandsRoute = (
  <Route
    path={navigationRoutes.qm_manage_commands}
    handle={{
      crumb: () => <BreadcrumbsItem path={navigationRoutes.qm_manage_commands} crumb="qm_manage" />,
    }}
    element={
      <RequiredAuth>
        <QmManageCommands />
      </RequiredAuth>
    }
  />
);
